var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg35(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3473_17557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.39981 10.1925L0.799805 11.2005L1.8078 7.6005L8.39981 1.0405C8.47429 0.964308 8.56333 0.903765 8.66149 0.862431C8.75973 0.821097 8.86525 0.799805 8.97181 0.799805C9.07837 0.799805 9.18389 0.821097 9.28213 0.862431C9.38029 0.903765 9.46933 0.964308 9.54381 1.0405L10.9598 2.4645C11.0348 2.53887 11.0943 2.62736 11.1349 2.72484C11.1756 2.82233 11.1964 2.9269 11.1964 3.0325C11.1964 3.13811 11.1756 3.24268 11.1349 3.34017C11.0943 3.43766 11.0348 3.52614 10.9598 3.6005L4.39981 10.1925Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3473_17557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2,
    height: 11.2,
    fill: "white",
    transform: "translate(0.399902 0.400391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg35);
export default __webpack_public_path__ + "static/media/svg35.0081d351dd1934fa2fc4a11776b772bc.svg";
export { ForwardRef as ReactComponent };